import axios from 'axios'
import apiConfig from '../apiConfig'

export function getVirtualBundleApi(payload = {}, page = 1, size = 10) {
  const url = `${apiConfig.virtualBundles.url}?page=${encodeURIComponent(page)}&size=${encodeURIComponent(size)}`
  return axios.post(url, payload, {
    headers: {
      'Content-Type': 'application/json',
      'X-Api-key': apiConfig.virtualBundles.apiKey,
    },
  })
}
